import { render } from "./TagMatrixTitle.vue?vue&type=template&id=1e70409e&scoped=true"
import script from "./TagMatrixTitle.vue?vue&type=script&lang=js"
export * from "./TagMatrixTitle.vue?vue&type=script&lang=js"

import "./TagMatrixTitle.vue?vue&type=style&index=0&id=1e70409e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e70409e"]])

export default __exports__